import { render, staticRenderFns } from "./loans.vue?vue&type=template&id=e2620938"
import script from "./loans.vue?vue&type=script&lang=js"
export * from "./loans.vue?vue&type=script&lang=js"
import style0 from "./common.less?vue&type=style&index=0&prod&lang=less&external"
import style1 from "./loans.less?vue&type=style&index=1&prod&lang=less&external"
import style2 from "../../../core/mixins.less?vue&type=style&index=2&prod&lang=less&external"
import style3 from "../../../core/icons.less?vue&type=style&index=3&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports